/*
 *  Copyright
 *
 *  Tegona S.A.
 *
 *  Tegona JS � 2017, Tegona S.A.
 *
 *  ALL RIGHTS RESERVED. THIS PROGRAM CONTAINS MATERIAL PROTECTED
 *  UNDER INTERNATIONAL AND SWITZERLAND COPYRIGHT LAWS AND TREATIES.
 *  ANY UNAUTHORIZED USE OF THE PROGRAM, INCLUDING REPRODUCTION,
 *  MODIFICATION, TRANSFER, TRANSMITTAL OR REPUBLICATION OF THIS
 *  MATERIAL IN ANY FORM OR BY ANY MEANS IS PROHIBITED WITHOUT
 *  SPECIFIC WRITTEN PERMISSION OF THE COPYRIGHT HOLDER.
 *
 *  copyright@tegona.com
 */

import React from 'react'
import R from 'ramda'
import moment from 'moment'
import { injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { List, ListItem, ListItemText, Divider, Chip, Collapse } from '@material-ui/core'
import { ExpandLess, ExpandMore } from '@material-ui/icons'

import * as constants from 'constants/Prestation'
import * as invitationConstants from 'constants/Invitation'
import * as loginConstants from 'constants/Login'

class InvitationPanel extends React.Component {

  constructor (props) {
    super(props)

    this.state = {
      open: true,
      invitations: undefined
    }
  }

  componentDidMount() {
    this.handleLoadInvitations()
  }

  componentDidUpdate(prevProps) {
    if (this.props.invitations !== prevProps.invitations) {
      this.handleLoadInvitations()
    }
  }

  handleLoadInvitations() {
    const defaultOpen = this.props.user.role !== loginConstants.INTERPRETER_ROLE

    let element = defaultOpen
      ? new Map()
      : this.props.invitations

    if (defaultOpen) {
      this.props.invitations &&
      this.props.invitations.forEach((invitations, dateObj) => {
        invitations = invitations.map(o => (
          {
            ...o,
            open: true
          }
        ))
        element.set(dateObj, invitations)
      })
    }

    this.setState({
      invitations: element
    })
  }

  handleChange(name, value) {
    this.setState({
      [name]: value
    })
  }

  render () {
    if (this.props.user.role === loginConstants.INTERPRETER_ROLE ||
        !this.state.invitations ||
        !this.state.invitations.size) {
      return <React.Fragment/>
    }

    let nestedItems = []
    this.state.invitations.forEach((invitations, date) => {
      nestedItems.push(
        <List
          key={date}
          style={this.props.style}
        >
          <ListItemText
            disabled={true}
            primary={this.props.intl.formatMessage(constants.messages.SEND_DATE) + ' ' + moment(date).format('DD.MM.YYYY')}
            style={{
              textAlign: 'center',
            }}
          />

          {
            invitations.map((obj) => {
              const stepName = R.path(['workflow_objects', 0, 'step_name'], obj)
              const email = R.path(['interpreter', 'identities', 0, 'emails'], obj)
              const phone = R.path(['interpreter', 'identities', 0, 'phone_numbers'], obj)

              return (
                <ListItem
                  key={date+obj.uid}
                  style={{
                    ...this.props.itemStyle,
                    ...styles.item
                  }}
                >
                  <ListItemText
                    disabled={true}
                    primary={this.props.interpreter(obj)}
                    secondary={
                      <React.Fragment>
                        <a style={styles.contactLink} href={`mailto:${email}`}>{email}</a>
                        {", "}
                        <a style={styles.contactLink} href={`tel:${phone.replace(/\s/g, '')}`}>{phone}</a>
                      </React.Fragment>
                    }
                  />

                  <Chip
                    label={R.path(['workflow_objects', 0, 'display_step_name'], obj)}
                    style={{
                      color: 'white',
                      backgroundColor: invitationConstants.INVITATION_STATUS_COLOR[stepName],
                      minWidth: 85,
                    }}
                  />
                </ListItem>
              )

            })
          }
        </List>
      )
    })

    return (
      <React.Fragment>
        <Divider/>
        <List>
          <ListItem
            button
            onClick={() => this.handleChange('open', !!!this.state.open)}
            style={{paddingLeft: 16, paddingRight: 16}}
          >
            <ListItemText
              primary={this.props.intl.formatMessage(constants.messages.DETAIL_INVITATIONS_LABEL)}
            />

            {
              this.state.open
                ? <ExpandLess />
                : <ExpandMore />
            }
          </ListItem>
        </List>

        <Collapse
          in={this.state.open}
        >
          {nestedItems}
        </Collapse>
      </React.Fragment>
    )
  }
}

const styles = {
  contactLink: {
    color: "inherit",
    textDecoration: "none",
  },
  item: {
    flexWrap: 'nowrap',
  }
}

const mapStateToProps = (state) => ({
  user: state.User.user,
})

export default connect(
  mapStateToProps, 
  undefined
)(injectIntl(InvitationPanel))



// WEBPACK FOOTER //
// ./src/components/applicant/prestation/dashboard/InvitationPanel.js